import React from 'react';
import { getPolyglot } from '../../../../../../../i18n';
import Link from '../../../../../../../theme/components/Link';
import { StyledMenuItemPrimary } from '../../../../../../../components/App/header/AvatarMenu/AvatarMenu';
import { RolesAdapter } from '../../../../../../../redux/rights/api/RightAdapter';
import { useGroups } from '../../../../../../../redux/groups/hooks/useGroups';
import { GroupType } from '../../../../../redux/group/model';

export const FreshwatchAppMenuLinks = (props: {
  listApps: string[];
  handleClose: () => void;
}) => {
  const { listApps, handleClose } = props;
  const { data: groups } = useGroups();

  const polyglot = getPolyglot();

  return listApps.map((stringApp: string) => (
    <Link to={`/${stringApp}`} onClick={handleClose} key={stringApp}>
      <StyledMenuItemPrimary>
        {polyglot.t(`nav.menu.${stringApp}`)}
      </StyledMenuItemPrimary>
    </Link>
  ));
};
